/* import __COLOCATED_TEMPLATE__ from './article-suggestions-users.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();